import React, { useEffect, useState, useCallback } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";

function App() {
  const { unityProvider,  isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener  } = useUnityContext({
    loaderUrl: "unity/Build/Build.loader.js",
    dataUrl: "unity/Build/Build.data.unityweb",
    frameworkUrl: "unity/Build/Build.framework.js.unityweb",
    codeUrl: "unity/Build/Build.wasm.unityweb",
    streamingAssetsUrl: "unity/StreamingAssets",
    companyName: "RanSecurity",
    productName: "Phish-Out",
    productVersion: "2.0",
  });

  const BackUrlLoginAzure = process.env.REACT_APP_REDIRECCION_BACK_LOGIN_AZURE_URL;

  const aspectRatio = 16 / 9;
  const [containerHeight, setContainerHeight] = useState(window.innerHeight - 50);
  const [containerWidth, setContainerWidth] = useState(window.innerWidth * 0.93);

  const [videosPrecargados, setVideosPrecargados] = useState({});

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth * 0.93;
      const newHeight = newWidth / aspectRatio;
 
      if (newHeight > window.innerHeight - 50) {
        setContainerWidth(window.innerHeight * aspectRatio * 0.93);
        setContainerHeight(window.innerHeight - 50);
      } else {
        setContainerWidth(newWidth);
        setContainerHeight(newHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [aspectRatio]);

  const handleFullscreenToggle = () => {
    const container = document.getElementById("unity-container");

    if (!document.fullscreenElement) {
      container.requestFullscreen().catch(err => {
        console.error(`Error al intentar entrar en modo pantalla completa: ${err}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const verificarOCargarVideo = async (url, reintentos = 3) => {
    try {
      const cacheName = "video-cache";
      const cache = await caches.open(cacheName);
      const cachedResponse = await cache.match(url);
  
      if (cachedResponse) {
        return cachedResponse.url;
      } else {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Error al descargar ${url}`);
        
        // Guarda el video en la caché
        console.warn("Videos cargados con exito");
        await cache.put(url, response.clone());
        return response.url;
      }
    } catch (error) {
      console.error(`Error en la verificación o descarga del video ${url}:`, error);
  
      // Si falló, intentamos de nuevo si hay reintentos disponibles
      if (reintentos > 0) {
        console.warn(`Reintentando... (${3 - reintentos} de 3)`);
        return verificarOCargarVideo(url, reintentos - 1);
      }
  
      return null; // Si ya no quedan reintentos, retornamos null
    }
  };
  
  // Función para precargar los videos con reintentos
  const precargarVideos = async () => {
    try {
      const videoUrls = [
        "/StreamingAssets/virusWeb.mp4",
        "/StreamingAssets/finalizacionWeb.mp4",
      ];
  
      const videos = {};
  
      for (const url of videoUrls) {
        const videoUrl = await verificarOCargarVideo(url);
        if (videoUrl) {
          videos[url] = videoUrl;
          console.warn("Videos cargados con exito");
        } else {
          console.error(`No se pudo precargar el video ${url} después de varios intentos.`);
        }
      }
  
      setVideosPrecargados(videos);
    } catch (error) {
      console.error("Error al precargar videos:", error);
    }
  };
  
  useEffect(() => {
    precargarVideos();
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const unityCanvas = document.querySelector("#unity-container canvas");
      if (document.fullscreenElement) {
        unityCanvas.style.width = "100%";
        unityCanvas.style.height = "100%";
      } else {
        unityCanvas.style.width = `${containerWidth}px`;
        unityCanvas.style.height = `${containerHeight}px`;
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, [containerWidth, containerHeight]);


  const manejarLoginAzure = useCallback(() => {
    window.location.href = BackUrlLoginAzure;
  }, []);

  const enviarDatosUnity = (datos) => {
    sendMessage("ManagerDatos", "RecibirDatosLoginAzure", datos);
  };
  
  useEffect(() => {
    if (isLoaded) {

     const rawQuery = window.location.search;
     const match = rawQuery.match(/data=([^&]*)/); // Extrae el valor después de 'data='
     let datos = "";

     if (match && match[1]) {
        datos = match[1]; // Esto obtiene el valor sin decodificar
     }
     enviarDatosUnity(datos); 
    }
  }, [isLoaded]); // Se ejecuta solo cuando Unity se haya cargado

  useEffect(() => {
    addEventListener("LoginAzure", manejarLoginAzure);
    return () => {
      removeEventListener("LoginAzure", manejarLoginAzure);
    };
  }, [addEventListener, removeEventListener, manejarLoginAzure]);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center", // Centrar el contenido verticalmente
        position: "relative",     // Para posicionar elementos de manera absoluta si es necesario
      }}
    >
      {!isLoaded && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60%",
            maxWidth: "400px",
            height: "30px",
            backgroundColor: "#ddd",
            borderRadius: "15px",
            overflow: "hidden",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              width: `${Math.round(loadingProgression * 100)}%`,
              height: "100%",
              backgroundColor: "#4caf50",
              transition: "width 0.3s ease",
            }}
          ></div>
        </div>
      )}
  
      <div
        id="unity-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "1",
          width: "100%",
        }}
      >
        <Unity
          unityProvider={unityProvider}
          style={{
            width: `${containerWidth}px`,
            height: `${containerHeight}px`,
            display: "block",
            visibility: isLoaded ? "visible" : "hidden",
          }}
        />
      </div>
  
      <button onClick={handleFullscreenToggle} style={{ padding: "10px 20px", fontSize: "16px", marginBottom: "3px", cursor: "pointer" }}>
      {document.fullscreenElement ? "Salir de Pantalla Completa" : "Pantalla Completa"}
      </button>
  
      <video src={videosPrecargados["/StreamingAssets/virusWeb.mp4"]} preload="auto" style={{ display: "none" }} />
      <video src={videosPrecargados["/StreamingAssets/finalizacionWeb.mp4"]} preload="auto" style={{ display: "none" }} />
    </div>
  );
}

export default App;